import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { Form, FieldTextInput, EditListingActionButton } from '../../components';
import config from '../../config';

import ManageAvailabilityCalendar from './ManageAvailabilityCalendar';
import css from './EditListingAvailabilityForm.css';

export class EditListingAvailabilityFormComponent extends Component {
  render() {
    return (
      <FinalForm
        {...this.props}
        render={formRenderProps => {
          const {
            className,
            rootClassName,
            disabled,
            ready,
            handleSubmit,
            intl,
            invalid,
            pristine,
            saveActionMsg,
            updated,
            updateError,
            updateInProgress,
            availability,
            availabilityPlan,
            listingId,
            form,
            onBackWithoutSubmit,
            handleChangeSeats,
            values,
          } = formRenderProps;

          const { seats } = values;

          const seatMessage = intl.formatMessage({ id: 'EditListingAvailabilityForm.seat' });
          const seatPlaceholderMessage = intl.formatMessage({
            id: 'EditListingAvailabilityForm.seatPlaceholder',
          });
          const seatRequired = validators.required(
            intl.formatMessage({
              id: 'EditListingAvailabilityForm.seatRequired',
            })
          );
          const minSeatRequired = validators.minValue(
            intl.formatMessage(
              {
                id: 'EditListingAvailabilityForm.minSeat',
              },
              { minSeat: config.listingMinimumSeats }
            ),
            config.listingMinimumSeats
          );

          const seatValidators = validators.composeValidators(seatRequired, minSeatRequired);

          const errorMessage = updateError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingAvailabilityForm.updateFailed" />
            </p>
          ) : null;

          const classes = classNames(rootClassName || css.root, className);
          const submitReady = (updated && pristine) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = invalid || disabled || submitInProgress;

          return (
            <Form className={classes} onSubmit={handleSubmit}>
              {errorMessage}
              <FieldTextInput
                id="seats"
                name="seats"
                className={css.title}
                type="number"
                label={seatMessage}
                placeholder={seatPlaceholderMessage}
                validate={seatValidators}
                step="1"
                min="1"
              />

              <OnChange name="seats">
                {(value, previous) => {
                  if (value !== previous) {
                    handleChangeSeats(value === '' ? '' : Number.parseInt(value));
                  }
                }}
              </OnChange>

              <div className={css.calendarWrapper}>
                <ManageAvailabilityCalendar
                  availability={availability}
                  availabilityPlan={availabilityPlan}
                  listingId={listingId}
                />
              </div>

              <EditListingActionButton
                invalid={invalid}
                nextBtnMessage={saveActionMsg}
                nextBtnClassName={css.submitButton}
                form={form}
                onBackWithoutSubmit={onBackWithoutSubmit}
                submitInProgress={submitInProgress}
                submitReady={submitReady}
                submitDisabled={submitDisabled}
              />
            </Form>
          );
        }}
      />
    );
  }
}

EditListingAvailabilityFormComponent.defaultProps = {
  updateError: null,
};

EditListingAvailabilityFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
  availability: object.isRequired,
  availabilityPlan: propTypes.availabilityPlan.isRequired,
};

export default compose(injectIntl)(EditListingAvailabilityFormComponent);
